angular.module 'zc.commonApi'

.factory "MongoParticularEvent", ($q, FacadeV2) ->


  class MongoParticularEvent

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}

        unless query.apikey
          return reject "No apikey"

        FacadeV2.request "/apikeys/#{query.apikey}/particular_events",
          params:
            match: query
            sort: options.sort
            limit: options.limit || 1000
          cache: false
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

  MongoParticularEvent



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_particular_event.service.coffee